import { AdminDeleteOrderItemRequest, AdminOrdersListRequest, AdminOrdersListResponse, AdminOrdersUpdateRequest } from "@/venit/services/model/techpubs-cms";
import axios, { AxiosResponse } from 'axios';

export default class OrdersService {

    public list(listRequest: AdminOrdersListRequest): Promise<AxiosResponse<AdminOrdersListResponse>> {
      return axios.post<AdminOrdersListResponse>(`/api/admin/orders/orders-list`, listRequest);
    }

    public update(updateRequest: AdminOrdersUpdateRequest): Promise<AxiosResponse<void>> {
      return axios.post(`/api/admin/orders/update`, updateRequest);
    }

    public deleteItem(request: AdminDeleteOrderItemRequest): Promise<AxiosResponse<void>> {
      return axios.post(`/api/admin/orders/delete-item`, request);
    }

}